import { extendTheme } from '@chakra-ui/react';
import { APP_FONT_FAMILY } from './constants/typography';

const config = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
};

/** Soft yellow → lime → mint accent (replaces former orange brand) */
const theme = extendTheme({
  config,
  fonts: {
    heading: APP_FONT_FAMILY,
    body: APP_FONT_FAMILY,
  },
  colors: {
    brand: {
      50: '#f7fee7',
      100: '#ecfccb',
      200: '#d9f99d',
      300: '#bef264',
      400: '#fde68a',
      500: '#a3e635',
      600: '#4ade80',
      700: '#22c55e',
      800: '#15803d',
      900: '#14532d',
    },
    surface: {
      950: '#050506',
      900: '#0a0a0b',
      800: '#121214',
      700: '#1c1c1f',
      600: '#27272c',
    },
  },
  styles: {
    global: (props) => ({
      'html, body, #root': {
        minHeight: '100%',
        fontFamily: APP_FONT_FAMILY,
        backgroundColor: props.colorMode === 'dark' ? '#0a0a0b' : '#f8fafc',
        color: props.colorMode === 'dark' ? 'rgba(255,255,255,0.92)' : '#1e293b',
      },
    }),
  },
  components: {
    Button: {
      baseStyle: { fontWeight: 'semibold', borderRadius: 'full' },
    },
  },
});

export default theme;
